export const CREATIVE_ROLES = [
    'Director',
    'Producer',
    'Executive Producer',
    'Associate Producer',
    'Line Producer',
    'Screenwriter',
    'Scriptwriter',
    'Story Editor',
    'Script Supervisor',
    'Director of Photography',
    'Cinematographer',
    'Camera Operator',
    'First Assistant Camera',
    'Second Assistant Camera',
    'Gaffer',
    'Best Boy Electric',
    'Key Grip',
    'Best Boy Grip',
    'Grip',
    'Sound Mixer',
    'Boom Operator',
    'Sound Designer',
    'Foley Artist',
    'ADR Mixer',
    'Editor',
    'Assistant Editor',
    'Colorist',
    'Visual Effects Supervisor',
    'VFX Artist',
    'Compositor',
    'Motion Graphics Designer',
    'Production Designer',
    'Art Director',
    'Set Designer',
    'Set Decorator',
    'Prop Master',
    'Costume Designer',
    'Wardrobe Supervisor',
    'Makeup Artist',
    'Hair Stylist',
    'Special Effects Makeup',
    'Stunt Coordinator',
    'Stunt Performer',
    'Casting Director',
    'Location Manager',
    'Production Manager',
    'Assistant Director',
    'Production Assistant',
    'Runner',
    'Catering',
    'Transportation Coordinator',
    'Driver',
    'Security',
    'Medical Officer',
    'Animal Wrangler',
    'Drone Operator',
    'Steadicam Operator',
    'Underwater Camera Operator',
    'Aerial Cinematographer',
    'Time-lapse Photographer',
    'Documentary Filmmaker',
    'News Cameraman',
    'Live Broadcast Technician',
    'Broadcast Engineer',
    'Video Engineer',
    'Technical Director',
    'Switcher Operator',
    'Graphics Operator',
    'Audio Engineer',
    'Lighting Director',
    'Stage Manager',
    'Floor Manager',
    'Talent Coordinator',
    'Choreographer',
    'Dance Captain',
    'Musical Director',
    'Composer',
    'Music Supervisor',
    'Soundtrack Producer',
    'Recording Engineer',
    'Mix Engineer',
    'Mastering Engineer',
    'Session Musician',
    'Orchestrator',
    'Arranger',
    'Lyricist',
    'Songwriter',
    'Music Producer',
    'Beat Maker',
    'DJ',
    'Live Sound Engineer',
    'Monitor Engineer',
    'FOH Engineer',
    'Backline Technician',
    'Instrument Tech',
    'Tuner',
    'Road Manager',
    'Tour Manager',
    'Booking Agent',
    'Talent Manager',
    'Artist Manager',
    'Publicist',
    'Marketing Manager',
    'Brand Manager',
    'Social Media Manager',
    'Content Creator',
    'Influencer',
    'YouTuber',
    'Streamer',
    'Podcaster',
    'Radio Host',
    'TV Host',
    'Presenter',
    'Anchor',
    'Reporter',
    'Journalist',
    'Photojournalist',
    'Photographer',
    'Portrait Photographer',
    'Wedding Photographer',
    'Fashion Photographer',
    'Commercial Photographer',
    'Product Photographer',
    'Architectural Photographer',
    'Landscape Photographer',
    'Wildlife Photographer',
    'Sports Photographer',
    'Event Photographer',
    'Photo Editor',
    'Retoucher',
    'Digital Artist',
    'Illustrator',
    'Graphic Designer',
    'UI/UX Designer',
    'Web Designer',
    'Logo Designer',
    'Brand Designer',
    'Animator',
    '2D Animator',
    '3D Animator',
    'Character Animator',
    'Rigging Artist',
    'Modeling Artist',
    'Texture Artist',
    'Lighting Artist',
    'Rendering Artist',
    'Storyboard Artist',
    'Concept Artist',
    'Character Designer',
    'Background Artist',
    'Layout Artist',
    'Clean-up Artist',
    'Inbetweener',
    'Key Animator',
    'Animation Director',
    'Creative Director',
    'Art Director',
    'Design Director',
    'Creative Lead',
    'Project Manager',
    'Account Manager',
    'Client Services',
    'Business Development',
    'Sales Representative',
    'Marketing Specialist',
    'Copywriter',
    'Content Writer',
    'Technical Writer',
    'Editor',
    'Proofreader',
    'Translator',
    'Interpreter',
    'Voice Actor',
    'Voice Over Artist',
    'Narrator',
    'Audiobook Narrator',
    'Dubbing Artist',
    'ADR Artist',
    'Looping Artist',
    'Foley Artist',
    'Sound Effects Designer',
    'Audio Post Producer',
    'Audio Mixer',
    'Mastering Engineer',
    'Recording Studio Manager',
    'Studio Assistant',
    'Session Coordinator',
    'Talent Booker',
    'Casting Assistant',
    'Talent Scout',
    'Model Scout',
    'Fashion Stylist',
    'Personal Stylist',
    'Wardrobe Stylist',
    'Fashion Editor',
    'Fashion Buyer',
    'Fashion Designer',
    'Costume Designer',
    'Textile Designer',
    'Pattern Maker',
    'Seamstress',
    'Tailor',
    'Alterations Specialist',
    'Jewelry Designer',
    'Accessories Designer',
    'Shoe Designer',
    'Bag Designer',
    'Fashion Model',
    'Runway Model',
    'Commercial Model',
    'Fitness Model',
    'Plus Size Model',
    'Petite Model',
    'Male Model',
    'Female Model',
    'Child Model',
    'Senior Model',
    'Hand Model',
    'Foot Model',
    'Parts Model',
    'Fashion Show Producer',
    'Runway Coordinator',
    'Fashion Show Director',
    'Backstage Manager',
    'Hair and Makeup Artist',
    'Nail Artist',
    'Beauty Consultant',
    'Cosmetician',
    'Esthetician',
    'Spa Manager',
    'Massage Therapist',
    'Personal Trainer',
    'Fitness Instructor',
    'Yoga Instructor',
    'Dance Instructor',
    'Choreographer',
    'Dance Captain',
    'Dance Company Director',
    'Ballet Master',
    'Ballet Mistress',
    'Dance Teacher',
    'Dance Studio Owner',
    'Dance Competition Judge',
    'Dance Recital Director',
    'Theater Director',
    'Stage Director',
    'Assistant Director',
    'Stage Manager',
    'Assistant Stage Manager',
    'Production Stage Manager',
    'Technical Director',
    'Lighting Designer',
    'Sound Designer',
    'Set Designer',
    'Costume Designer',
    'Props Master',
    'Wardrobe Supervisor',
    'Makeup Designer',
    'Hair Designer',
    'Wig Master',
    'Special Effects Designer',
    'Pyrotechnician',
    'Rigging Designer',
    'Automation Designer',
    'Scenic Artist',
    'Paint Charge',
    'Carpenter',
    'Welder',
    'Electrician',
    'Plumber',
    'HVAC Technician',
    'Stagehand',
    'Flyman',
    'Spotlight Operator',
    'Follow Spot Operator',
    'Light Board Operator',
    'Sound Board Operator',
    'Video Operator',
    'Projection Designer',
    'Video Designer',
    'Media Server Operator',
    'Live Video Mixer',
    'Broadcast Technician',
    'Satellite Uplink Operator',
    'Mobile Unit Operator',
    'ENG Cameraman',
    'EFP Cameraman',
    'Studio Cameraman',
    'Robotic Camera Operator',
    'Jib Operator',
    'Crane Operator',
    'Dolly Grip',
    'Actor',
    'Actress',
    // ... (add more as needed)
];
